import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
export const List = ({ items, renderItem, ...externalProps }) => {
    return (_jsx(Box, { as: "ul", margin: 0, overflowY: "scroll", padding: 0, flex: 1, ...externalProps, children: items.map((item) => (_jsx(Box, { as: "li", display: "flex", flexDirection: "column", borderBottomColor: "color.surface.light.default", borderBottomStyle: "solid", gap: "spacing.8", children: renderItem(item) }, item.key))) }));
};
